export default __webpack_public_path__ + "src/assets/tasks/enig/EMO_feil1ab.mp3";